<template>
    <div class="billing-main-scroll">
        <div class="billing-section-title">{{ $t('common.billing.modulesTitle') }}</div>
        <div class="billing-modules-filter">
            <button :class="['billing-filter-btn', {'billing-filter-btn--active': bs.state.moduleFilter === 'all'}]"
                    @click="bs.setModuleFilter('all')">{{ $t('common.billing.filterAll') }}</button>
            <button :class="['billing-filter-btn', {'billing-filter-btn--active': bs.state.moduleFilter === 'owned'}]"
                    @click="bs.setModuleFilter('owned')">{{ $t('common.billing.filterOwned') }}</button>
            <button :class="['billing-filter-btn', {'billing-filter-btn--active': bs.state.moduleFilter === 'available'}]"
                    @click="bs.setModuleFilter('available')">{{ $t('common.billing.filterAvailable') }}</button>
        </div>

        <div class="billing-modules-grid">
            <div v-for="mod in filteredModules" :key="mod.id" class="billing-module-card">
                <div class="billing-module-header">
                    <div class="billing-module-icon" :style="{background: mod.color}">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
                        </svg>
                    </div>
                    <div class="billing-module-info">
                        <div class="billing-module-name">{{ mod.name }}</div>
                        <div class="billing-module-desc">{{ mod.description }}</div>
                    </div>
                </div>
                <div class="billing-module-footer">
                    <template v-if="mod.owned">
                        <span class="billing-module-owned">{{ $t('common.billing.owned') }} &#10003;</span>
                    </template>
                    <template v-else-if="mod.price === 0">
                        <span class="billing-module-free">{{ $t('common.billing.free') }}</span>
                    </template>
                    <template v-else>
                        <span class="billing-module-price">{{ bs.formatPrice(mod.price) }}&#8378;/{{ $t('common.billing.month') }}</span>
                        <button class="billing-module-buy-btn"
                                @click="bs.openCheckout({type: 'module', name: mod.name + ' ' + $t('common.billing.module'), moduleId: mod.id, amount: mod.price})">
                            {{ $t('common.billing.buyNow') }}
                        </button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import billingService from './billingService'

export default {
    name: 'BillingModules',
    computed: {
        bs() {
            return billingService
        },
        filteredModules() {
            const filter = billingService.state.moduleFilter
            if (filter === 'owned') return billingService.MODULES.filter(m => m.owned)
            if (filter === 'available') return billingService.MODULES.filter(m => !m.owned)
            return billingService.MODULES
        },
    },
}
</script>
